import { UploadPolicy } from '@libraries/secure-uploader-client';
import { createAction, props } from '@ngrx/store';

export const IsMobile = createAction('[UI State] On Mobile');

export const IsTablet = createAction('[UI State] On Tablet');

export const IsDesktop = createAction('[UI State] On Desktop');

export const HideLeft = createAction('[UI State] Hide Left');

export const ShowLeft = createAction('[UI State] Show Left');

export const setUploadPolicy = createAction(
  '[UI State] Set Upload Policy',
  props<{ policy: UploadPolicy }>()
);
